// extracted by mini-css-extract-plugin
export default {"select":"src-feature-ui-__country-flags_select"};